export default {"src":"/_next/static/media/gradient.a446e542.svg","height":451,"width":1018,"blurWidth":0,"blurHeight":0};